import { useEffect } from "react";
import { useGoogleLogin } from "@react-oauth/google";

import { simplyClick } from "shared/helpers/analytics";
import { useTranslation } from "react-i18next";

/**
 * Button for Google Sign in.

 * @return {jsx}
 *
 */
const ButtonGoogle = (props) => {
  const {
    text,
    className,
    id,
    type,
    handleGoogleLogin,
    handleBeforeClick,
    initHandleClick,
    step,
    checkBox,
    setTermsError,
  } = props;
  const isLoginPage = window.location.pathname.includes("/login/");
  const { t } = useTranslation("auth");
  const isSignInButton = id?.includes("login-google");

  /**
   * Execute current coe from parent component
   */
  const handleClick = () => {
    if (!checkBox && !isLoginPage && !isSignInButton) {
      simplyClick("err_lnd_sign_up_checkbox_nocheckbox");
      setTermsError(t("termsError"));
      return;
    }

    if (typeof handleBeforeClick === "function") {
      handleBeforeClick();
    }

    handleGoogleClick();
    if (id === "login-google") {
      simplyClick(
        isLoginPage
          ? "cl_lnd_sign_in_login_sign_in_google"
          : "cl_home_p_login_sign_in_google",
        null
      );
    } else if (id === "sign__up-google") {
      const prefix = step ? `cl_home_p_sign_up_${step}_` : `cl_home_p_sign_up_`;
      simplyClick(`${prefix}sign_up_google`);
    }
  };

  const handleGoogleClick = useGoogleLogin({
    scope:
      "email profile openid https://www.googleapis.com/auth/userinfo.profile" +
      " https://www.googleapis.com/auth/userinfo.email" +
      " https://www.googleapis.com/auth/user.gender.read" +
      " https://www.googleapis.com/auth/plus.login" +
      " https://www.googleapis.com/auth/user.birthday.read",
    onSuccess: (tokenResponse) => {
      if (tokenResponse.access_token) {
        handleGoogleLogin(null, tokenResponse);
        return;
      }

      handleGoogleLogin(true, null);
    },
    onError: () => {
      handleGoogleLogin(true, null);
    },
  });

  useEffect(() => {
    if (typeof initHandleClick === "function") {
      initHandleClick(handleClick);
    }
  }, []);

  return (
    <button className={className} onClick={handleClick} id={id} type={type}>
      <span> {text}</span>
    </button>
  );
};

export default ButtonGoogle;
